import MessageSimplifiedDTO from "features/messages/dto/MessageSimplifiedDTO";
import PagedDataResultUnreadDTO from "features/shared/dtos/PagedDataResultUnreadDTO";

export enum MessagesActionTypes {
    SET_MESSAGES = "@@messages/SET_MESSAGES"
}

export type MessagesAction = 
| {type: MessagesActionTypes.SET_MESSAGES, data: PagedDataResultUnreadDTO<MessageSimplifiedDTO>}

export const setMessages = (data: PagedDataResultUnreadDTO<MessageSimplifiedDTO>): MessagesAction => {
    return {
        type: MessagesActionTypes.SET_MESSAGES,
        data: data
    }
}